module.exports = __webpack_public_path__ + "img/Kaufmann_Kauffrau_LM_006.44d37e9c.jpg";